/* eslint-disable import/prefer-default-export */

export var toggleChecked = function toggleChecked(item) {
  item.chipCheckboxProps.isChecked = !item.chipCheckboxProps.isChecked;
};